module.exports = __webpack_public_path__ + "static/media/readingOver.76e5a509.mp3";